import { actionCreatorFactory } from "typescript-fsa";

const actionFactory = actionCreatorFactory("MODULF_OPENREGISTER_SELECTION");

export const SEARCH_OPENREGISTER_RECORDS = actionFactory<{
	activityId: string;
	pageIndex: number;
	query: string;
}>("SEARCH_OPENREGISTER_RECORDS");

export const CONFIRM_SELECT_OPENREGISTER_RECORD = actionFactory<{
	activityId: string;
	recordId: string;
}>("CONFIRM_SELECT_OPENREGISTER_RECORD");
